module.exports = __webpack_public_path__ + "img/微信图片_20200803182357.af63c717.png";